import axios from 'axios'

import { CommunicationApi } from '../../publish/communication/apis/communication-api'
import { Configuration } from '../../publish/communication/configuration'
import { setupAxiosInterceptors } from '../axios-interceptor-utils'

export class CommunicationService extends CommunicationApi {
  constructor(
    protected basePath: string,
    private getTokenFn?: () => Promise<string>,
  ) {
    super(new Configuration({ basePath: basePath }), basePath, axios.create())
    setupAxiosInterceptors(this.axios, this.getTokenFn)
  }
}
